module.exports = __webpack_public_path__ + "img/baise11.ff0e6a6c.png";